import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { ServiceItemDetailResponse } from '../model/serviceitemsdetailinfo';

@Injectable()
export class ServiceItemDetailService {

    constructor(public http: HttpClient) {
    }

    // function call to fetch service item detail
    public getServiceItemDetail(itemId: number): Observable<ServiceItemDetailResponse> {
        return this.http.get<ServiceItemDetailResponse>(CommonConstants.SERVICE_VERSION_PATH_V1
            + '/customer/ci/items/' + itemId);
    }

    public getOutageServiceItemDetail(itemId: number): Observable<ServiceItemDetailResponse> {
        return this.http.get<ServiceItemDetailResponse>(CommonConstants.SERVICE_VERSION_PATH_V1
            + '/customer/outages/' + itemId);
    }
}
